import React from "react";
import { observer } from "mobx-react";
import SparkleIcon from "Components/common/SparkleIcon";
import userDetail from "Stores/userDetail";
import copilotStore from "Stores/copilotStore";

// Starting points, one per job the copilot does. Cards, not chips: each names
// the outcome and what happens when clicked (the Agent Studio template grid).
const TEMPLATES = [
  {
    icon: "group",
    title: "Find my buyers",
    desc: "People matching your ICP, from your seller profile, ready to add to a list.",
    prompt: "Find the people who buy what I sell"
  },
  {
    icon: "business",
    title: "Research an account",
    desc: "Fit, timing and who to reach at one company before you write.",
    prompt: "Research an account for me and tell me who to reach"
  },
  {
    icon: "send",
    title: "Write a sequence",
    desc: "A multi-step campaign drafted from your positioning, for you to review.",
    prompt: "Write a sequence to book meetings with my ideal customers"
  },
  {
    icon: "trending_up",
    title: "What moved this week",
    desc: "Replies, opens and the sequences that changed since you last looked.",
    prompt: "What moved in my sequences this week?"
  }
];

// The blank state states the job, not the time of day: eyebrow, a two-tone
// headline and one line of what happens next, over a soft accent glow.
export const CopilotGreeting = observer(() => {
  const firstName = userDetail?.userInfo?.firstName || "";
  return (
    <div className="copilotHero__greeting">
      <span className="copilotHero__eyebrow">
        <SparkleIcon />
        Copilot
      </span>
      <h1>
        Tell me who you sell to{firstName ? `, ${firstName}` : ""}.{" "}
        <span className="copilotHero__accent">I&apos;ll find them.</span>
      </h1>
      <p>
        Find buyers, research them and get a campaign ready for you to review,
        in plain English.
      </p>
    </div>
  );
});

export const CopilotCapabilities = observer(() => (
  <div className="copilotHero__below">
    <div className="copilotHero__divider">
      <span>or start with</span>
    </div>
    <div className="copilotHero__templates">
      {TEMPLATES.map(t => (
        <button
          type="button"
          key={t.title}
          className="copilotHero__template"
          onClick={() => copilotStore.sendUserMessage(t.prompt)}
        >
          <span className="copilotHero__templateIcon">
            <i className="material-icons-outlined">{t.icon}</i>
          </span>
          <span className="copilotHero__templateBody">
            <span className="copilotHero__templateTitle">{t.title}</span>
            <span className="copilotHero__templateDesc">{t.desc}</span>
          </span>
        </button>
      ))}
    </div>
  </div>
));
